import { render } from "./real_name_detail.vue?vue&type=template&id=4df05f64&scoped=true&ts=true"
import script from "./real_name_detail.vue?vue&type=script&lang=ts"
export * from "./real_name_detail.vue?vue&type=script&lang=ts"

import "./real_name_detail.vue?vue&type=style&index=0&id=4df05f64&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df05f64"]])

export default __exports__